import dataBeleidNietErnstigVka from "../../../../src/data/niet-ernstige-bloedingen-onder-vka.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBeleidNietErnstigVka,
  BasicSchematic,
  React
};